import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import InputTooltip from './InputTooltip';
import { mergeHelperAndHint, renderQuestionLabel } from '../../utils/common';
var InfoSelect = function (_a) {
    var label = _a.label, question = _a.question, questionKey = _a.questionKey, options = _a.options, value = _a.value, handleChange = _a.handleChange, _b = _a.error, error = _b === void 0 ? false : _b, helper = _a.helper, hint = _a.hint;
    var dropdownRef = useRef(null);
    var selectRef = useRef(null);
    var _c = useState(false), showOptions = _c[0], setShowOptions = _c[1];
    var _d = useState(null), hoveredOption = _d[0], setHoveredOption = _d[1];
    var _e = useState({
        x: 0,
        y: 0,
        showOnLeft: false
    }), tooltipPosition = _e[0], setTooltipPosition = _e[1];
    var selectHandler = function (selectedValue) {
        handleChange(selectedValue);
        setShowOptions(false);
        setHoveredOption(null);
    };
    var onElemClick = function (elem) {
        var clickables = [dropdownRef, selectRef];
        if (clickables.every(function (c) { return c.current && !c.current.contains(elem); })) {
            setShowOptions(false);
        }
    };
    useEffect(function () {
        var onClickHandler = function (ev) {
            onElemClick(ev.target);
        };
        document.addEventListener('click', onClickHandler);
        return function () {
            document.removeEventListener('click', onClickHandler);
        };
    }, []);
    var handleMouseEnter = function (option, event) {
        if (option.tooltip) {
            setHoveredOption(option);
            var rect = event.currentTarget.getBoundingClientRect();
            var dropDown = dropdownRef.current.getBoundingClientRect();
            var spaceOnRight = window.innerWidth - rect.right;
            var spaceOnLeft = rect.left;
            var showOnLeft = spaceOnRight < 200 && spaceOnLeft > 200;
            setTooltipPosition({
                x: showOnLeft ? dropDown.left - 10 : dropDown.right + 10,
                y: rect.top + rect.height / 2,
                showOnLeft: showOnLeft
            });
        }
    };
    var handleMouseLeave = function () {
        setHoveredOption(null);
    };
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === value; });
    var displayValue = selectedOption
        ? selectedOption.caption
        : 'Select the option';
    return (React.createElement("div", { className: "flex flex-col items-start relative w-full h-full justify-end" },
        React.createElement("label", { htmlFor: "".concat(questionKey), className: "text-base md:text-xl flex ".concat(error ? 'text-[#EA4335]' : 'text-[#252846]', " font-medium w-full text-left") },
            renderQuestionLabel(question === null || question === void 0 ? void 0 : question.isHtml, label),
            (helper || hint) && (React.createElement(InputTooltip, { text: mergeHelperAndHint(helper, hint) }))),
        React.createElement("div", { className: "flex items-center justify-between w-full px-3 py-2 md:py-2.5 text-base md:text-xl leading-tight border-2 mt-2 cursor-pointer ".concat(error
                ? 'border-[#EA4335] bg-[#FBD9D7] text-[#EA4335]'
                : 'border-[#E9EDF7] bg-[#F8FAFE] text-[#252846]', " ").concat(!selectedOption ? (error ? 'text-[#EA4335]' : 'text-gray-500') : '', " rounded-lg md:rounded-xl focus:outline-primary hover:border-primary transition-colors"), onClick: function () { return setShowOptions(!showOptions); }, ref: selectRef },
            React.createElement("span", { className: "flex-1 text-left truncate" }, displayValue),
            React.createElement(FontAwesomeIcon, { icon: showOptions ? faChevronUp : faChevronDown, className: "text-gray-400 ml-2" })),
        showOptions && (React.createElement("div", { ref: dropdownRef, className: "absolute top-[calc(100%+4px)] left-0 right-0 p-1 bg-[#F8FAFE] rounded-xl border-2 border-[#E9EDF7] max-h-[320px] overflow-y-auto z-[56] shadow-lg custom-scrollbar" }, options && options.length > 0 ? (React.createElement("ul", { className: "flex flex-col" }, options.map(function (opt, idx) { return (React.createElement("li", { key: "".concat(opt.value), className: "flex-1" },
            React.createElement("button", { className: "flex w-full items-start px-3 py-2 min-h-[44px] text-left text-sm md:text-base font-medium whitespace-normal break-words rounded-md transition-colors hover:bg-slate-100 ".concat(value === opt.value ? 'bg-blue-50 text-primary' : ''), onClick: function () { return selectHandler(opt.value); }, onMouseEnter: function (e) { return handleMouseEnter(opt, e); }, onMouseLeave: handleMouseLeave }, opt.caption))); }))) : (React.createElement("p", { className: "my-4 text-base mx-auto text-center text-gray-500" }, "No Options")))),
        hoveredOption && hoveredOption.tooltip && (React.createElement("div", { className: "fixed bg-gray-800 text-white text-sm px-3 py-2 rounded-lg shadow-lg z-[1000] max-w-xs text-left", style: {
                left: tooltipPosition.x,
                top: tooltipPosition.y,
                transform: "translateY(-50%) ".concat(tooltipPosition.showOnLeft ? 'translateX(-100%)' : '')
            } },
            hoveredOption.tooltip,
            React.createElement("div", { className: "absolute top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-transparent ".concat(tooltipPosition.showOnLeft
                    ? 'right-0 translate-x-1 border-l-4 border-l-gray-800'
                    : 'left-0 -translate-x-1 border-r-4 border-r-gray-800') })))));
};
export default InfoSelect;
